import { render, staticRenderFns } from "./TrashCompanyHistorical.vue?vue&type=template&id=37a5f5f2&scoped=true&"
import script from "./TrashCompanyHistorical.vue?vue&type=script&lang=js&"
export * from "./TrashCompanyHistorical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a5f5f2",
  null
  
)

export default component.exports